import { render, staticRenderFns } from "./OrtopediHastaListesi.vue?vue&type=template&id=58202f1a&scoped=true&"
import script from "./OrtopediHastaListesi.vue?vue&type=script&lang=js&"
export * from "./OrtopediHastaListesi.vue?vue&type=script&lang=js&"
import style0 from "./OrtopediHastaListesi.vue?vue&type=style&index=0&id=58202f1a&lang=scss&scoped=true&"
import style1 from "./OrtopediHastaListesi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58202f1a",
  null
  
)

export default component.exports